import { ModelSagres } from "../../model-sagres";

export class LicitacaoFracassado extends ModelSagres {
  DeItemMatServ: string;
  DeUnidadeMedida: string;
  FlFracassado: string;
  IdLicitacao: number;
  NuSequencialItem: number;
  QtItemMatServ: number;
  VlTotalEstimado: number;
  VlUnitarioEstimado: number;

  //TO-DO: Centralizar estes tratamentos no ModelSagres. Dá pra loopar o obj e tratar todas as datas.
  //também dá pra criar enums para estas strings sim/nao, ativo/inativo etc
  tratarDadosDaAPI(): void {
    if (this.FlFracassado) {
      this.FlFracassado = this.FlFracassado === "S" ? "Sim" : "Não";
    }
  }
}
